import { render, staticRenderFns } from "./SMSManager.vue?vue&type=template&id=b8b54e54&scoped=true&"
import script from "./SMSManager.vue?vue&type=script&lang=js&"
export * from "./SMSManager.vue?vue&type=script&lang=js&"
import style0 from "./SMSManager.vue?vue&type=style&index=0&id=b8b54e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b54e54",
  null
  
)

export default component.exports